import { Box, Button, Chip } from "@mui/material";
import { blue, green, orange, purple, red } from "@mui/material/colors";
import { useMemo, useState } from "react";

const palette = {
	ink: "#111110",
	ink2: "#3a3a38",
	ink3: "#6b6b68",
	ink4: "#9b9b97",
	surface: "#fafaf8",
	surface2: "#f2f1ee",
	surface3: "#e8e7e2",
	border: "rgba(0,0,0,.08)",
	border2: "rgba(0,0,0,.14)",
	sidebar: "#141412",
	sidebarText: "#c8c8c4",
	sidebarMuted: "#70706b",
	accent: "#c8a96e",
	green: "#15803d",
	greenBg: "#dcfce7",
	amber: "#b45309",
	amberBg: "#fef3c7",
	red: "#b91c1c",
	redBg: "#fee2e2",
	blue: "#2563eb",
	blueBg: "#dbeafe",
	purple: "#7c3aed",
	purpleBg: "#ede9fe",
};

const categories = ["Buttons", "Zippers", "Labels", "Thread", "Elastic", "Lace", "Ribbon", "Velcro", "Other"];
const vendors = ["Buttons India Ltd", "YKK Zippers", "Thread Masters", "Label Co", "Trims Pro"];
const pageList = [
	{ key: "catalog", label: "Trims Catalog" },
	{ key: "stock", label: "Stock Management" },
	{ key: "orders", label: "Trims Orders" },
	{ key: "fob", label: "FOB Orders" },
	{ key: "jw", label: "Job Work (JW)" },
	{ key: "own", label: "Own Production PO" },
];

const catalog = [
	{
		id: 1,
		name: "Metal snap button 10mm",
		code: "TRM-BTN-001",
		category: "Buttons",
		unit: "PCS",
		cost: 0.5,
		stock: 12500,
		reorder: 500,
		vendor: "Buttons India Ltd",
		leadtime: 7,
		moq: 1000,
	},
	{
		id: 2,
		name: "Horn button 4-hole 11mm",
		code: "TRM-BTN-002",
		category: "Buttons",
		unit: "PCS",
		cost: 1.2,
		stock: 8200,
		reorder: 500,
		vendor: "Buttons India Ltd",
		leadtime: 7,
		moq: 500,
	},
	{
		id: 3,
		name: "YKK invisible zip 18cm",
		code: "TRM-ZIP-001",
		category: "Zippers",
		unit: "PCS",
		cost: 8.5,
		stock: 3400,
		reorder: 200,
		vendor: "YKK Zippers",
		leadtime: 10,
		moq: 500,
	},
	{
		id: 4,
		name: "Metal zip 5 inch nickel",
		code: "TRM-ZIP-002",
		category: "Zippers",
		unit: "PCS",
		cost: 6.0,
		stock: 2100,
		reorder: 200,
		vendor: "YKK Zippers",
		leadtime: 10,
		moq: 500,
	},
	{
		id: 5,
		name: "Woven label 3x5cm",
		code: "TRM-LBL-001",
		category: "Labels",
		unit: "PCS",
		cost: 2.5,
		stock: 15000,
		reorder: 1000,
		vendor: "Label Co",
		leadtime: 5,
		moq: 2000,
	},
	{
		id: 6,
		name: "Printed care label 3cm",
		code: "TRM-LBL-002",
		category: "Labels",
		unit: "PCS",
		cost: 1.0,
		stock: 18000,
		reorder: 1000,
		vendor: "Label Co",
		leadtime: 5,
		moq: 2000,
	},
	{
		id: 7,
		name: "Polyester thread 120/2",
		code: "TRM-THR-001",
		category: "Thread",
		unit: "MTR",
		cost: 0.08,
		stock: 50000,
		reorder: 5000,
		vendor: "Thread Masters",
		leadtime: 3,
		moq: 10000,
	},
	{
		id: 8,
		name: "Cotton thread 40s",
		code: "TRM-THR-002",
		category: "Thread",
		unit: "MTR",
		cost: 0.12,
		stock: 38000,
		reorder: 5000,
		vendor: "Thread Masters",
		leadtime: 3,
		moq: 10000,
	},
	{
		id: 9,
		name: "Elastic band 2cm black",
		code: "TRM-ELS-001",
		category: "Elastic",
		unit: "MTR",
		cost: 1.5,
		stock: 4200,
		reorder: 500,
		vendor: "Trims Pro",
		leadtime: 5,
		moq: 1000,
	},
	{
		id: 10,
		name: "Velcro tape 2.5cm",
		code: "TRM-VEL-001",
		category: "Velcro",
		unit: "MTR",
		cost: 3.2,
		stock: 1800,
		reorder: 200,
		vendor: "Trims Pro",
		leadtime: 5,
		moq: 500,
	},
];

const stockMovements = [
	{
		id: "STK-2501",
		code: "TRM-BTN-001",
		name: "Metal snap button 10mm",
		vendor: "Buttons India Ltd",
		warehouse: "Jigani",
		inward: 2000,
		issued: 550,
		reserved: 120,
		stock: 12500,
		status: "Healthy",
	},
	{
		id: "STK-2502",
		code: "TRM-ZIP-001",
		name: "YKK invisible zip 18cm",
		vendor: "YKK Zippers",
		warehouse: "Gurugram",
		inward: 1200,
		issued: 460,
		reserved: 110,
		stock: 3400,
		status: "Healthy",
	},
	{
		id: "STK-2503",
		code: "TRM-LBL-001",
		name: "Woven label 3x5cm",
		vendor: "Label Co",
		warehouse: "West Bengal",
		inward: 1500,
		issued: 350,
		reserved: 280,
		stock: 15000,
		status: "Healthy",
	},
	{
		id: "STK-2504",
		code: "TRM-THR-001",
		name: "Polyester thread 120/2",
		vendor: "Thread Masters",
		warehouse: "Maharashtra",
		inward: 5000,
		issued: 1800,
		reserved: 600,
		stock: 50000,
		status: "Healthy",
	},
	{
		id: "STK-2505",
		code: "TRM-ELS-001",
		name: "Elastic band 2cm black",
		vendor: "Trims Pro",
		warehouse: "Jigani",
		inward: 900,
		issued: 220,
		reserved: 150,
		stock: 4200,
		status: "Healthy",
	},
];

const orders = [
	{
		po: "TRM/PO/2501",
		vendor: "Buttons India Ltd",
		date: "2026-05-02",
		delivery: "2026-05-20",
		status: "Pending",
		qty: 12000,
		value: 62000,
	},
	{
		po: "TRM/PO/2502",
		vendor: "YKK Zippers",
		date: "2026-05-03",
		delivery: "2026-05-22",
		status: "Received",
		qty: 5400,
		value: 46800,
	},
	{
		po: "TRM/PO/2503",
		vendor: "Thread Masters",
		date: "2026-05-05",
		delivery: "2026-05-18",
		status: "Received",
		qty: 42000,
		value: 8900,
	},
	{ po: "TRM/PO/2504", vendor: "Label Co", date: "2026-05-09", delivery: "2026-05-24", status: "Pending", qty: 22000, value: 37000 },
];

const productionRows = [
	{
		type: "FOB",
		style: "RR-2479 Slim Oxford Shirt",
		vendor: "Buttons India Ltd",
		qty: 1800,
		trims: 4,
		delivery: "2026-05-28",
		status: "In Progress",
	},
	{
		type: "FOB",
		style: "RM-1140 Floral Wrap Dress",
		vendor: "YKK Zippers",
		qty: 920,
		trims: 3,
		delivery: "2026-06-02",
		status: "Pending",
	},
	{
		type: "JW",
		style: "RZ-0840 Runner Pro Sneaker",
		vendor: "Trims Pro",
		qty: 640,
		trims: 3,
		delivery: "2026-05-30",
		status: "In Progress",
	},
	{
		type: "JW",
		style: "RO-0391 Kids Jogger",
		vendor: "Thread Masters",
		qty: 1240,
		trims: 3,
		delivery: "2026-06-05",
		status: "Pending",
	},
	{
		type: "OWN",
		style: "RR-2479 Slim Oxford Shirt",
		vendor: "Jigani Unit 1",
		qty: 2100,
		trims: 4,
		delivery: "2026-05-26",
		status: "Released",
	},
];

const styleTrims = {
	"RR-2479 Slim Oxford Shirt": [
		{ trim: "Horn button 4-hole 11mm", code: "TRM-BTN-002", perPc: 6, vendor: "Buttons India Ltd" },
		{ trim: "Woven label 3x5cm", code: "TRM-LBL-001", perPc: 1, vendor: "Label Co" },
		{ trim: "Printed care label 3cm", code: "TRM-LBL-002", perPc: 1, vendor: "Label Co" },
		{ trim: "Polyester thread 120/2", code: "TRM-THR-001", perPc: 50, vendor: "Thread Masters" },
	],
	"RM-1140 Floral Wrap Dress": [
		{ trim: "YKK invisible zip 18cm", code: "TRM-ZIP-001", perPc: 1, vendor: "YKK Zippers" },
		{ trim: "Woven label 3x5cm", code: "TRM-LBL-001", perPc: 1, vendor: "Label Co" },
		{ trim: "Cotton thread 40s", code: "TRM-THR-002", perPc: 80, vendor: "Thread Masters" },
	],
	"RZ-0840 Runner Pro Sneaker": [
		{ trim: "Elastic band 2cm black", code: "TRM-ELS-001", perPc: 30, vendor: "Trims Pro" },
		{ trim: "Woven label 3x5cm", code: "TRM-LBL-001", perPc: 2, vendor: "Label Co" },
		{ trim: "Cotton thread 40s", code: "TRM-THR-002", perPc: 120, vendor: "Thread Masters" },
	],
	"RO-0391 Kids Jogger": [
		{ trim: "Elastic band 2cm black", code: "TRM-ELS-001", perPc: 40, vendor: "Trims Pro" },
		{ trim: "Metal snap button 10mm", code: "TRM-BTN-001", perPc: 2, vendor: "Buttons India Ltd" },
		{ trim: "Polyester thread 120/2", code: "TRM-THR-001", perPc: 60, vendor: "Thread Masters" },
	],
};

const fmt = (value) => Number(value).toLocaleString("en-IN");
const money = (value) => `Rs ${Number(value).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
const fmtDate = (value) => new Date(value).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

const TrimsERP = () => {
	const [page, setPage] = useState("catalog");
	const [search, setSearch] = useState("");
	const [category, setCategory] = useState("");
	const [stockFilter, setStockFilter] = useState("");
	const [orderTab, setOrderTab] = useState("all");
	const [sidebarPage, setSidebarPage] = useState("catalog");
	const [modal, setModal] = useState("");

	const filteredCatalog = useMemo(() => {
		const q = search.trim().toLowerCase();
		return catalog.filter((row) => {
			const matchesQuery = !q || [row.name, row.code, row.vendor, row.category].join(" ").toLowerCase().includes(q);
			const matchesCategory = !category || row.category === category;
			const matchesStock =
				!stockFilter ||
				(stockFilter === "in" && row.stock > row.reorder) ||
				(stockFilter === "low" && row.stock <= row.reorder && row.stock > 0) ||
				(stockFilter === "out" && row.stock === 0);
			return matchesQuery && matchesCategory && matchesStock;
		});
	}, [search, category, stockFilter]);

	const metrics = useMemo(() => {
		return {
			total: catalog.length,
			categories: new Set(catalog.map((row) => row.category)).size,
			vendors: new Set(catalog.map((row) => row.vendor)).size,
			inStock: catalog.filter((row) => row.stock > 0).length,
			lowStock: catalog.filter((row) => row.stock <= row.reorder && row.stock > 0).length,
		};
	}, []);

	const orderRows =
		orderTab === "pending"
			? orders.filter((row) => row.status === "Pending")
			: orderTab === "received"
				? orders.filter((row) => row.status === "Received")
				: orders;
	const styleLines = styleTrims["RR-2479 Slim Oxford Shirt"] || [];

	const openModal = (key) => setModal(key);
	const closeModal = () => setModal("");

	const pageTitle =
		page === "catalog"
			? "Trims Catalog"
			: page === "stock"
				? "Stock Management"
				: page === "orders"
					? "Trims Orders"
					: page === "fob"
						? "FOB Orders"
						: page === "jw"
							? "Job Work (JW) Orders"
							: "Own Production PO";

	const pageSub =
		page === "catalog"
			? "All trims items | categorized | vendor mapping"
			: page === "stock"
				? "Inventory levels | warehouse-wise | reorder alerts"
				: page === "orders"
					? "Purchase orders to vendors | delivery tracking"
					: page === "fob"
						? "Free on Board | Style -> Trims -> Vendor nomination -> Qty -> FOB vendor delivery"
						: page === "jw"
							? "Style -> Trims -> Vendor nomination -> Qty -> JW vendor delivery"
							: "Internal production purchase orders | trims allocation";

	const PageTopbar = ({ children }) => (
		<div className="topbar">
			<div>
				<h1>{pageTitle}</h1>
				<div className="tg">{pageSub}</div>
			</div>
			<div className="topbar-right">{children}</div>
		</div>
	);

	return (
		<Box
			sx={{
				bgcolor: palette.surface,
				color: palette.ink,
				minHeight: "100vh",
				p: 0,
				width: "100%",
				overflowX: "hidden",
				boxSizing: "border-box",
				fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
			}}>
			<style>{`
				.trims-app{display:grid;grid-template-columns:240px minmax(0,1fr);min-height:100vh;width:100%}
				.sidebar{width:240px;background:${palette.sidebar};min-height:100vh;position:sticky;top:0;display:flex;flex-direction:column;z-index:100;overflow:auto}
				.sb-logo{padding:20px;border-bottom:1px solid rgba(255,255,255,0.06)}
				.sb-logo .wm{font-size:18px;color:${palette.accent};font-weight:700;letter-spacing:.02em}
				.sb-logo .sub{font-size:10px;color:${palette.sidebarMuted};margin-top:3px;text-transform:uppercase;letter-spacing:.07em}
				.sb-section{padding:14px 12px 6px}
				.sb-label{font-size:9px;color:${palette.sidebarMuted};letter-spacing:.1em;text-transform:uppercase;padding:0 8px;margin-bottom:8px}
				.nav-btn{display:flex;align-items:center;gap:10px;padding:9px 10px;border-radius:6px;cursor:pointer;color:${palette.sidebarMuted};font-size:12px;transition:all .12s;margin-bottom:2px;background:transparent;border:0;width:100%;text-align:left}
				.nav-btn:hover{background:rgba(255,255,255,0.05);color:${palette.sidebarText}}
				.nav-btn.active{background:rgba(200,169,110,0.15);color:${palette.accent}}
				.sb-footer{padding:14px 16px;border-top:1px solid rgba(255,255,255,0.06);margin-top:auto;font-size:10px;color:${palette.sidebarMuted}}

				.main{padding:24px 28px 60px;min-width:0}
				.page{display:none}
				.page.active{display:block}
				.topbar{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:20px;gap:12px;flex-wrap:wrap}
				.topbar h1{font-size:26px;font-weight:700;line-height:1.1;letter-spacing:-.02em;color:${palette.ink}}
				.topbar .tg{font-size:11px;color:${palette.ink3};margin-top:3px}
				.topbar-right{display:flex;gap:8px;flex-wrap:wrap}
				.pbtn{font-size:11px;padding:6px 14px;border-radius:20px;border:1px solid ${palette.border2};background:#fff;cursor:pointer;color:${palette.ink2};font-family:'Roboto',sans-serif;transition:all .12s}
				.pbtn:hover{background:${palette.surface2}}
				.pbtn.primary{background:${palette.ink};color:#fff;border-color:${palette.ink}}
				.pbtn.soft{background:#fff}

				.card{background:#fff;border:1px solid ${palette.border};border-radius:12px;padding:18px 20px;margin-bottom:14px}
				.card-title{font-size:13px;font-weight:700;color:${palette.ink};margin-bottom:14px;display:flex;align-items:center;justify-content:space-between}
				.ct-sub{font-size:10px;color:${palette.ink4};font-weight:400}
				.kpi-strip{display:grid;grid-template-columns:repeat(5,1fr);gap:10px;margin-bottom:16px}
				.kpi{background:#fff;border:1px solid ${palette.border};border-radius:12px;padding:12px 14px}
				.kpi .kl{font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:${palette.ink3};margin-bottom:6px}
				.kpi .kv{font-size:22px;font-weight:700;color:${palette.ink};line-height:1}
				.kpi .ks{font-size:10px;color:${palette.ink4};margin-top:4px}

				.search-bar{display:flex;gap:8px;margin-bottom:14px}
				.search-bar input,.search-bar select{font-size:12px;padding:7px 12px;border:1px solid ${palette.border2};border-radius:6px;background:#fff;color:${palette.ink};font-family:'Roboto',sans-serif}
				.search-bar input{flex:1}

				.tabs{display:flex;gap:6px;margin-bottom:16px;border-bottom:1px solid ${palette.border};padding-bottom:8px;flex-wrap:wrap}
				.tab{font-size:11px;padding:5px 12px;border-radius:6px 6px 0 0;cursor:pointer;background:none;border:none;color:${palette.ink3};font-family:'Roboto',sans-serif}
				.tab.on{background:${palette.ink};color:#fff}
				.tab-content{display:none}
				.tab-content.on{display:block}

				.tbl{width:100%;border-collapse:collapse}
				.tbl th{font-size:10px;color:${palette.ink4};text-align:left;padding:0 8px 8px;font-weight:500;border-bottom:1px solid ${palette.border}}
				.tbl th.r{text-align:right}
				.tbl td{font-size:11px;padding:8px;border-bottom:1px solid ${palette.border};color:${palette.ink2};vertical-align:middle}
				.tbl td.r{text-align:right;font-family:monospace;color:${palette.ink}}
				.tbl tbody tr:hover td{background:${palette.surface2}}
				.tbl tr:last-child td{border-bottom:none}
				.tbl .act-cell{display:flex;gap:6px;align-items:center}
				.tbl .act-btn{font-size:10px;padding:3px 8px;border-radius:4px;border:1px solid ${palette.border2};background:#fff;cursor:pointer;color:${palette.ink3}}
				.tbl .act-btn:hover{background:${palette.surface2};color:${palette.ink}}

				.stock-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:12px}
				.stock-card{background:#fff;border:1px solid ${palette.border};border-radius:12px;padding:14px;cursor:pointer}
				.stock-card:hover{border-color:${palette.accent};box-shadow:0 4px 12px rgba(0,0,0,.08)}
				.stock-card .sc-img{width:100%;height:140px;background:${palette.surface2};border-radius:8px;margin-bottom:10px;display:flex;align-items:center;justify-content:center;color:${palette.ink4};font-size:11px;border:1px solid ${palette.border}}
				.stock-card .sc-name{font-size:12px;font-weight:700;color:${palette.ink};margin-bottom:3px}
				.stock-card .sc-code{font-size:10px;font-family:monospace;color:${palette.ink4};margin-bottom:8px}
				.stock-card .sc-stock{display:flex;justify-content:space-between;font-size:11px;margin-top:8px;padding-top:8px;border-top:1px solid ${palette.border}}
				.stock-card .sc-stock .label{color:${palette.ink4}}
				.stock-card .sc-stock .val{font-weight:700;color:${palette.ink}}

				.line-items{margin-bottom:14px}
				.line-item{background:${palette.surface2};border:1px solid ${palette.border};border-radius:8px;padding:12px 14px;margin-bottom:8px;position:relative}
				.line-item .li-grid{display:grid;grid-template-columns:2fr 1.5fr 1fr 1fr 80px;gap:10px;align-items:end}
				.line-item .li-remove{position:absolute;top:10px;right:10px;width:24px;height:24px;border-radius:50%;background:#fff;border:1px solid ${palette.border2};cursor:pointer;color:${palette.red};display:flex;align-items:center;justify-content:center;font-size:14px}
				.line-item .li-remove:hover{background:${palette.red};color:#fff;border-color:${palette.red}}
				.line-add{padding:10px;border:1px dashed ${palette.border2};border-radius:8px;text-align:center;cursor:pointer;color:${palette.ink3};font-size:11px}
				.line-add:hover{background:${palette.surface2};color:${palette.ink};border-color:${palette.accent}}

				.form-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:14px}
				.fg{display:flex;flex-direction:column;gap:4px;flex:1}
				.fg label{font-size:11px;color:${palette.ink3};font-weight:500}
				.fg input,.fg select,.fg textarea{font-size:12px;padding:7px 10px;border:1px solid ${palette.border2};border-radius:6px;background:#fff;font-family:'Roboto',sans-serif;color:${palette.ink};width:100%}
				.fg input:focus,.fg select:focus,.fg textarea:focus{outline:none;border-color:${palette.accent}}
				.fg textarea{resize:vertical;min-height:60px;line-height:1.5}

				.sum-panel{background:${palette.surface2};border:1px solid ${palette.border};border-radius:8px;padding:14px 16px}
				.sum-row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid ${palette.border};font-size:12px}
				.sum-row:last-child{border-bottom:none;font-weight:700;font-size:13px}
				.sum-row .sl{color:${palette.ink3}}
				.sum-row .sv{color:${palette.ink};font-family:monospace}

				.modal{display:none;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.4);z-index:1000;align-items:center;justify-content:center}
				.modal.on{display:flex}
				.modal-box{background:#fff;border-radius:12px;padding:0;width:90%;max-width:700px;max-height:90vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,0.3)}
				.modal-header{padding:18px 24px;border-bottom:1px solid ${palette.border};display:flex;align-items:center;justify-content:space-between}
				.modal-header h2{font-size:20px;font-weight:700}
				.modal-close{width:28px;height:28px;border-radius:50%;border:none;background:${palette.surface2};cursor:pointer;color:${palette.ink3};font-size:18px;display:flex;align-items:center;justify-content:center}
				.modal-close:hover{background:${palette.surface3};color:${palette.ink}}
				.modal-body{padding:20px 24px}
				.modal-footer{padding:16px 24px;border-top:1px solid ${palette.border};display:flex;gap:8px;justify-content:flex-end}
				.modal-footer .pbtn{padding:7px 16px}

				.nav-wrap{display:flex;gap:8px}
				.nav-btn-ghost{display:flex;align-items:center;gap:8px;padding:9px 10px;border-radius:6px;cursor:pointer;color:${palette.sidebarMuted};font-size:12px;background:transparent;border:0;width:100%;text-align:left}

				@media (max-width: 1100px){
					.trims-app{grid-template-columns:1fr}
					.sidebar{position:relative;width:100%;min-height:auto}
					.main{padding:16px}
					.kpi-strip{grid-template-columns:repeat(2,1fr)}
					.form-grid{grid-template-columns:1fr}
					.line-item .li-grid{grid-template-columns:1fr}
				}
			`}</style>

			<div className="trims-app">
				<aside className="sidebar">
					<div className="sb-section">
						{pageList.slice(0, 3).map((item) => (
							<button
								key={item.key}
								className={`nav-btn ${sidebarPage === item.key ? "active" : ""}`}
								onClick={() => {
									setSidebarPage(item.key);
									setPage(item.key);
								}}>
								{item.label}
							</button>
						))}
					</div>
					<div className="sb-section">
						<div className="sb-label">Production orders</div>
						{pageList.slice(3).map((item) => (
							<button
								key={item.key}
								className={`nav-btn ${sidebarPage === item.key ? "active" : ""}`}
								onClick={() => {
									setSidebarPage(item.key);
									setPage(item.key);
								}}>
								{item.label}
							</button>
						))}
					</div>
					<div className="sb-footer">SS25 | Trims Module v1.0</div>
				</aside>

				<main className="main">
					{page === "catalog" && (
						<section className="page active" id="page-catalog">
							<PageTopbar>
								<Button className="pbtn soft" onClick={() => openModal("add")}>
									Add item
								</Button>
								<Button className="pbtn primary" onClick={() => openModal("add")}>
									Add trims item
								</Button>
							</PageTopbar>
							<div className="kpi-strip">
								<div className="kpi">
									<div className="kl">Total items</div>
									<div className="kv">{metrics.total}</div>
									<div className="ks">in catalog</div>
								</div>
								<div className="kpi">
									<div className="kl">Categories</div>
									<div className="kv">{metrics.categories}</div>
									<div className="ks">trims types</div>
								</div>
								<div className="kpi">
									<div className="kl">Vendors</div>
									<div className="kv">{metrics.vendors}</div>
									<div className="ks">nominated</div>
								</div>
								<div className="kpi">
									<div className="kl">In stock</div>
									<div className="kv">{metrics.inStock}</div>
									<div className="ks">items available</div>
								</div>
								<div className="kpi">
									<div className="kl">Low stock</div>
									<div className="kv">{metrics.lowStock}</div>
									<div className="ks">need reorder</div>
								</div>
							</div>
							<div className="search-bar">
								<input
									placeholder="Search trims by name, code, category..."
									value={search}
									onChange={(e) => setSearch(e.target.value)}
								/>
								<select value={category} onChange={(e) => setCategory(e.target.value)}>
									<option value="">All categories</option>
									{categories.map((item) => (
										<option key={item} value={item}>
											{item}
										</option>
									))}
								</select>
								<select value={stockFilter} onChange={(e) => setStockFilter(e.target.value)}>
									<option value="">All stock levels</option>
									<option value="in">In stock</option>
									<option value="low">Low stock</option>
									<option value="out">Out of stock</option>
								</select>
							</div>
							<div className="stock-grid">
								{filteredCatalog.map((row) => {
									const isLow = row.stock <= row.reorder && row.stock > 0;
									const isOut = row.stock === 0;
									return (
										<div className="stock-card" key={row.id}>
											<div className="sc-img">No Image</div>
											<Chip
												size="small"
												label={row.category}
												sx={{
													bgcolor:
														row.category === "Buttons"
															? blue[50]
															: row.category === "Zippers"
																? orange[50]
																: row.category === "Thread"
																	? green[50]
																	: purple[50],
													color:
														row.category === "Buttons"
															? blue[900]
															: row.category === "Zippers"
																? orange[900]
																: row.category === "Thread"
																	? green[900]
																	: purple[900],
												}}
											/>
											<div className="sc-name">{row.name}</div>
											<div className="sc-code">{row.code}</div>
											<div className="sc-stock">
												<span className="label">Vendor</span>
												<span className="val">{row.vendor}</span>
											</div>
											<div className="sc-stock">
												<span className="label">Stock</span>
												<span className="val">{fmt(row.stock)}</span>
											</div>
											<div className="sc-stock">
												<span className="label">Status</span>
												<Chip
													size="small"
													label={isOut ? "Out" : isLow ? "Low" : "OK"}
													sx={{
														height: 20,
														fontSize: 10,
														bgcolor: isOut ? red[50] : isLow ? orange[50] : green[50],
														color: isOut ? red[900] : isLow ? orange[900] : green[900],
													}}
												/>
											</div>
										</div>
									);
								})}
							</div>
						</section>
					)}

					{page === "stock" && (
						<section className="page active" id="page-stock">
							<PageTopbar>
								<Button className="pbtn soft">Stock adjustment</Button>
								<Button className="pbtn primary" onClick={() => openModal("stock")}>
									Stock IN
								</Button>
							</PageTopbar>
							<div className="card">
								<div className="card-title">
									Stock inventory table <span className="ct-sub">all trims items</span>
								</div>
								<table className="tbl">
									<thead>
										<tr>
											<th>Item</th>
											<th>Vendor</th>
											<th>Warehouse</th>
											<th className="r">Inward</th>
											<th className="r">Issued</th>
											<th className="r">Reserved</th>
											<th className="r">On Hand</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{stockMovements.map((row) => (
											<tr key={row.id}>
												<td>
													<strong>{row.code}</strong>
													<br />
													<span style={{ color: palette.ink4, fontSize: 10 }}>{row.name}</span>
												</td>
												<td>{row.vendor}</td>
												<td>{row.warehouse}</td>
												<td className="r">{fmt(row.inward)}</td>
												<td className="r">{fmt(row.issued)}</td>
												<td className="r">{fmt(row.reserved)}</td>
												<td className="r">{fmt(row.stock)}</td>
												<td>
													<Chip
														size="small"
														label={row.status}
														sx={{ height: 20, fontSize: 10, bgcolor: green[50], color: green[900] }}
													/>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</section>
					)}

					{page === "orders" && (
						<section className="page active" id="page-orders">
							<PageTopbar>
								<Button className="pbtn soft">Export</Button>
								<Button className="pbtn primary" onClick={() => openModal("order")}>
									New trims order
								</Button>
							</PageTopbar>
							<div className="tabs">
								<button className={`tab ${orderTab === "all" ? "on" : ""}`} onClick={() => setOrderTab("all")}>
									All orders
								</button>
								<button className={`tab ${orderTab === "pending" ? "on" : ""}`} onClick={() => setOrderTab("pending")}>
									Pending
								</button>
								<button
									className={`tab ${orderTab === "received" ? "on" : ""}`}
									onClick={() => setOrderTab("received")}>
									Received
								</button>
							</div>
							<div className="card">
								<table className="tbl">
									<thead>
										<tr>
											<th>PO</th>
											<th>Vendor</th>
											<th>Order Date</th>
											<th>Expected Delivery</th>
											<th className="r">Qty</th>
											<th className="r">Value</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{orderRows.map((row) => (
											<tr key={row.po}>
												<td>{row.po}</td>
												<td>{row.vendor}</td>
												<td>{fmtDate(row.date)}</td>
												<td>{fmtDate(row.delivery)}</td>
												<td className="r">{fmt(row.qty)}</td>
												<td className="r">{money(row.value)}</td>
												<td>
													<Chip
														size="small"
														label={row.status}
														sx={{
															height: 20,
															fontSize: 10,
															bgcolor: row.status === "Received" ? green[50] : orange[50],
															color: row.status === "Received" ? green[900] : orange[900],
														}}
													/>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</section>
					)}

					{page === "fob" && (
						<section className="page active" id="page-fob">
							<PageTopbar>
								<Button className="pbtn soft">Export</Button>
								<Button className="pbtn primary" onClick={() => openModal("fob")}>
									New FOB order
								</Button>
							</PageTopbar>
							<div className="card">
								<div className="card-title">
									FOB order list <span className="ct-sub">all FOB orders</span>
								</div>
								<table className="tbl">
									<thead>
										<tr>
											<th>Style</th>
											<th>Vendor</th>
											<th className="r">Qty</th>
											<th>Delivery</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{productionRows
											.filter((row) => row.type === "FOB")
											.map((row) => (
												<tr key={row.style}>
													<td>{row.style}</td>
													<td>{row.vendor}</td>
													<td className="r">{fmt(row.qty)}</td>
													<td>{fmtDate(row.delivery)}</td>
													<td>
														<Chip
															size="small"
															label={row.status}
															sx={{
																height: 20,
																fontSize: 10,
																bgcolor: row.status === "In Progress" ? blue[50] : orange[50],
																color: row.status === "In Progress" ? blue[900] : orange[900],
															}}
														/>
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
							<div className="card">
								<div className="card-title">
									Style trims requirement <span className="ct-sub">RR-2479 Slim Oxford Shirt</span>
								</div>
								<table className="tbl">
									<thead>
										<tr>
											<th>Trim</th>
											<th>Vendor</th>
											<th className="r">Per Pc</th>
											<th>Code</th>
										</tr>
									</thead>
									<tbody>
										{styleLines.map((row) => (
											<tr key={row.code}>
												<td>{row.trim}</td>
												<td>{row.vendor}</td>
												<td className="r">{fmt(row.perPc)}</td>
												<td>{row.code}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</section>
					)}

					{page === "jw" && (
						<section className="page active" id="page-jw">
							<PageTopbar>
								<Button className="pbtn soft">Export</Button>
								<Button className="pbtn primary" onClick={() => openModal("jw")}>
									New JW order
								</Button>
							</PageTopbar>
							<div className="card">
								<div className="card-title">
									Job work order list <span className="ct-sub">all JW orders</span>
								</div>
								<table className="tbl">
									<thead>
										<tr>
											<th>Style</th>
											<th>Vendor</th>
											<th className="r">Qty</th>
											<th className="r">Trims</th>
											<th>Delivery</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{productionRows
											.filter((row) => row.type === "JW")
											.map((row) => (
												<tr key={row.style}>
													<td>{row.style}</td>
													<td>{row.vendor}</td>
													<td className="r">{fmt(row.qty)}</td>
													<td className="r">{row.trims}</td>
													<td>{fmtDate(row.delivery)}</td>
													<td>
														<Chip
															size="small"
															label={row.status}
															sx={{
																height: 20,
																fontSize: 10,
																bgcolor: row.status === "In Progress" ? purple[50] : orange[50],
																color: row.status === "In Progress" ? purple[900] : orange[900],
															}}
														/>
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</section>
					)}

					{page === "own" && (
						<section className="page active" id="page-own">
							<PageTopbar>
								<Button className="pbtn soft">Export</Button>
								<Button className="pbtn primary" onClick={() => openModal("own")}>
									Generate PO
								</Button>
							</PageTopbar>
							<div className="card">
								<div className="card-title">
									Own production PO list <span className="ct-sub">all internal POs</span>
								</div>
								<table className="tbl">
									<thead>
										<tr>
											<th>Style</th>
											<th>Unit</th>
											<th className="r">Qty</th>
											<th className="r">Trims</th>
											<th>Delivery</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{productionRows
											.filter((row) => row.type === "OWN")
											.map((row) => (
												<tr key={row.style}>
													<td>{row.style}</td>
													<td>{row.vendor}</td>
													<td className="r">{fmt(row.qty)}</td>
													<td className="r">{row.trims}</td>
													<td>{fmtDate(row.delivery)}</td>
													<td>
														<Chip
															size="small"
															label={row.status}
															sx={{ height: 20, fontSize: 10, bgcolor: green[50], color: green[900] }}
														/>
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</section>
					)}
				</main>
			</div>

			<div className={`modal ${modal === "add" ? "on" : ""}`}>
				<div className="modal-box">
					<div className="modal-header">
						<h2>Add trims item</h2>
						<button className="modal-close" onClick={closeModal}>
							×
						</button>
					</div>
					<div className="modal-body">
						<div className="form-grid">
							<div className="fg">
								<label>Item name*</label>
								<input placeholder="e.g. Metal snap button" />
							</div>
							<div className="fg">
								<label>Category*</label>
								<select defaultValue="">
									<option value="">Select</option>
									{categories.map((cat) => (
										<option key={cat} value={cat}>
											{cat}
										</option>
									))}
								</select>
							</div>
							<div className="fg">
								<label>Item code</label>
								<input placeholder="Auto-generated" disabled />
							</div>
						</div>
						<div className="form-grid">
							<div className="fg">
								<label>Unit</label>
								<select defaultValue="PCS">
									<option>PCS</option>
									<option>MTR</option>
									<option>KG</option>
									<option>SET</option>
								</select>
							</div>
							<div className="fg">
								<label>Unit cost (Rs)</label>
								<input type="number" step="0.01" placeholder="0.00" />
							</div>
							<div className="fg">
								<label>Reorder level</label>
								<input type="number" placeholder="500" />
							</div>
						</div>
						<div className="form-grid">
							<div className="fg">
								<label>Primary vendor</label>
								<select defaultValue="">
									<option value="">Select vendor</option>
									{vendors.map((vendor) => (
										<option key={vendor} value={vendor}>
											{vendor}
										</option>
									))}
								</select>
							</div>
							<div className="fg">
								<label>Lead time (days)</label>
								<input type="number" placeholder="7" />
							</div>
							<div className="fg">
								<label>MOQ</label>
								<input type="number" placeholder="1000" />
							</div>
						</div>
						<div className="fg">
							<label>Description</label>
							<textarea placeholder="Additional details..." />
						</div>
					</div>
					<div className="modal-footer">
						<button className="pbtn" onClick={closeModal}>
							Cancel
						</button>
						<button className="pbtn primary" onClick={closeModal}>
							Add item
						</button>
					</div>
				</div>
			</div>

			<div className={`modal ${modal === "stock" ? "on" : ""}`}>
				<div className="modal-box">
					<div className="modal-header">
						<h2>Stock IN</h2>
						<button className="modal-close" onClick={closeModal}>
							×
						</button>
					</div>
					<div className="modal-body">
						<div className="form-grid">
							<div className="fg">
								<label>Trims item*</label>
								<select defaultValue="">
									<option value="">Select item</option>
									{catalog.map((row) => (
										<option key={row.code} value={row.code}>
											{row.name}
										</option>
									))}
								</select>
							</div>
							<div className="fg">
								<label>Quantity*</label>
								<input type="number" placeholder="0" />
							</div>
							<div className="fg">
								<label>Date</label>
								<input type="date" defaultValue="2026-05-18" />
							</div>
						</div>
						<div className="form-grid">
							<div className="fg">
								<label>Vendor</label>
								<select defaultValue="">
									<option value="">Select vendor</option>
									{vendors.map((vendor) => (
										<option key={vendor} value={vendor}>
											{vendor}
										</option>
									))}
								</select>
							</div>
							<div className="fg">
								<label>Invoice #</label>
								<input placeholder="INV-001" />
							</div>
							<div className="fg">
								<label>Warehouse</label>
								<select defaultValue="Jigani">
									<option>Jigani</option>
									<option>Gurugram</option>
									<option>West Bengal</option>
									<option>Maharashtra</option>
								</select>
							</div>
						</div>
						<div className="fg">
							<label>Notes</label>
							<textarea placeholder="Additional notes..." />
						</div>
					</div>
					<div className="modal-footer">
						<button className="pbtn" onClick={closeModal}>
							Cancel
						</button>
						<button className="pbtn primary" onClick={closeModal}>
							Record stock IN
						</button>
					</div>
				</div>
			</div>

			<div className={`modal ${modal === "order" ? "on" : ""}`}>
				<div className="modal-box">
					<div className="modal-header">
						<h2>New trims order</h2>
						<button className="modal-close" onClick={closeModal}>
							×
						</button>
					</div>
					<div className="modal-body">
						<div className="form-grid">
							<div className="fg">
								<label>Vendor*</label>
								<select defaultValue="">
									<option value="">Select vendor</option>
									{vendors.map((vendor) => (
										<option key={vendor} value={vendor}>
											{vendor}
										</option>
									))}
								</select>
							</div>
							<div className="fg">
								<label>Order date</label>
								<input type="date" defaultValue="2026-05-18" />
							</div>
							<div className="fg">
								<label>Expected delivery</label>
								<input type="date" />
							</div>
						</div>
						<div className="fg">
							<label>PO number</label>
							<input placeholder="Auto-generated" disabled />
						</div>
						<div style={{ margin: "14px 0 8px", fontSize: 11, fontWeight: 500, color: palette.ink3 }}>Order items</div>
						<div className="line-items">
							<div className="line-item">
								<button type="button" className="li-remove">
									×
								</button>
								<div className="li-grid">
									<div className="fg">
										<label>Trims item</label>
										<select defaultValue="">
											<option value="">Select</option>
											{catalog.map((row) => (
												<option key={row.code} value={row.code}>
													{row.name}
												</option>
											))}
										</select>
									</div>
									<div className="fg">
										<label>Vendor nomination</label>
										<select defaultValue="Primary">
											<option>Primary</option>
											<option>Secondary</option>
										</select>
									</div>
									<div className="fg">
										<label>Qty</label>
										<input type="number" placeholder="0" />
									</div>
									<div className="fg">
										<label>Rate (Rs)</label>
										<input type="number" step="0.01" placeholder="0.00" />
									</div>
									<div className="fg">
										<label>Total</label>
										<input type="text" disabled value="Rs 0" />
									</div>
								</div>
							</div>
						</div>
						<div className="line-add">Add item</div>
						<div className="sum-panel" style={{ marginTop: 14 }}>
							<div className="sum-row">
								<span className="sl">Subtotal</span>
								<span className="sv">Rs 0.00</span>
							</div>
							<div className="sum-row">
								<span className="sl">Tax (18% GST)</span>
								<span className="sv">Rs 0.00</span>
							</div>
							<div className="sum-row">
								<span className="sl">Total</span>
								<span className="sv">Rs 0.00</span>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<button className="pbtn" onClick={closeModal}>
							Cancel
						</button>
						<button className="pbtn primary" onClick={closeModal}>
							Create order
						</button>
					</div>
				</div>
			</div>

			<div className={`modal ${modal === "fob" ? "on" : ""}`}>
				<div className="modal-box">
					<div className="modal-header">
						<h2>New FOB order</h2>
						<button className="modal-close" onClick={closeModal}>
							×
						</button>
					</div>
					<div className="modal-body">
						<div className="form-grid">
							<div className="fg">
								<label>Style*</label>
								<select defaultValue="">
									<option value="">Select style</option>
									<option>RR-2479 Slim Oxford Shirt</option>
									<option>RM-1140 Floral Wrap Dress</option>
									<option>RZ-0840 Runner Pro Sneaker</option>
									<option>RO-0391 Kids Jogger</option>
								</select>
							</div>
							<div className="fg">
								<label>Qty*</label>
								<input type="number" placeholder="Order quantity" />
							</div>
							<div className="fg">
								<label>Delivery date</label>
								<input type="date" />
							</div>
						</div>
						<div className="fg">
							<label>FOB vendor (final delivery)*</label>
							<select defaultValue="">
								<option value="">Select FOB vendor</option>
								<option>FOB Garments Pvt Ltd</option>
								<option>Export House India</option>
								<option>Global Apparel Co</option>
								<option>Textile Exports Ltd</option>
							</select>
						</div>
						<div style={{ margin: "14px 0 8px", fontSize: 11, fontWeight: 500, color: palette.ink3 }}>
							Trims requirement
						</div>
						<div className="line-items">
							{styleLines.map((row) => (
								<div className="line-item" key={row.code}>
									<div className="li-grid">
										<div className="fg">
											<label>Trim</label>
											<input defaultValue={row.trim} />
										</div>
										<div className="fg">
											<label>Vendor</label>
											<input defaultValue={row.vendor} />
										</div>
										<div className="fg">
											<label>Per Pc</label>
											<input defaultValue={row.perPc} />
										</div>
										<div className="fg">
											<label>Code</label>
											<input defaultValue={row.code} />
										</div>
										<div className="fg">
											<label>Type</label>
											<input defaultValue="Required" />
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="fg">
							<label>Special instructions</label>
							<textarea placeholder="Delivery instructions, packing notes..." />
						</div>
					</div>
					<div className="modal-footer">
						<button className="pbtn" onClick={closeModal}>
							Cancel
						</button>
						<button className="pbtn primary" onClick={closeModal}>
							Create FOB order
						</button>
					</div>
				</div>
			</div>

			<div className={`modal ${modal === "jw" ? "on" : ""}`}>
				<div className="modal-box">
					<div className="modal-header">
						<h2>New job work order</h2>
						<button className="modal-close" onClick={closeModal}>
							×
						</button>
					</div>
					<div className="modal-body">
						<div className="form-grid">
							<div className="fg">
								<label>Style*</label>
								<select defaultValue="">
									<option value="">Select style</option>
									<option>RR-2479 Slim Oxford Shirt</option>
									<option>RM-1140 Floral Wrap Dress</option>
									<option>RZ-0840 Runner Pro Sneaker</option>
									<option>RO-0391 Kids Jogger</option>
								</select>
							</div>
							<div className="fg">
								<label>Qty*</label>
								<input type="number" placeholder="Order quantity" />
							</div>
							<div className="fg">
								<label>Delivery date</label>
								<input type="date" />
							</div>
						</div>
						<div className="fg">
							<label>JW vendor (job worker)*</label>
							<select defaultValue="">
								<option value="">Select JW vendor</option>
								<option>Stitching Masters Pvt Ltd</option>
								<option>Job Works India</option>
								<option>Craftsmen Co</option>
								<option>Garment Makers Ltd</option>
							</select>
						</div>
						<div style={{ margin: "14px 0 8px", fontSize: 11, fontWeight: 500, color: palette.ink3 }}>
							Trims requirement
						</div>
						<div className="line-items">
							{styleLines.map((row) => (
								<div className="line-item" key={row.code}>
									<div className="li-grid">
										<div className="fg">
											<label>Trim</label>
											<input defaultValue={row.trim} />
										</div>
										<div className="fg">
											<label>Vendor</label>
											<input defaultValue={row.vendor} />
										</div>
										<div className="fg">
											<label>Per Pc</label>
											<input defaultValue={row.perPc} />
										</div>
										<div className="fg">
											<label>Code</label>
											<input defaultValue={row.code} />
										</div>
										<div className="fg">
											<label>Type</label>
											<input defaultValue="Required" />
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="fg">
							<label>Special instructions</label>
							<textarea placeholder="Job work instructions..." />
						</div>
					</div>
					<div className="modal-footer">
						<button className="pbtn" onClick={closeModal}>
							Cancel
						</button>
						<button className="pbtn primary" onClick={closeModal}>
							Create JW order
						</button>
					</div>
				</div>
			</div>

			<div className={`modal ${modal === "own" ? "on" : ""}`}>
				<div className="modal-box">
					<div className="modal-header">
						<h2>Generate own production PO</h2>
						<button className="modal-close" onClick={closeModal}>
							×
						</button>
					</div>
					<div className="modal-body">
						<div className="form-grid">
							<div className="fg">
								<label>Style*</label>
								<select defaultValue="">
									<option value="">Select style</option>
									<option>RR-2479 Slim Oxford Shirt</option>
									<option>RM-1140 Floral Wrap Dress</option>
									<option>RZ-0840 Runner Pro Sneaker</option>
									<option>RO-0391 Kids Jogger</option>
								</select>
							</div>
							<div className="fg">
								<label>Qty*</label>
								<input type="number" placeholder="Production quantity" />
							</div>
							<div className="fg">
								<label>Production date</label>
								<input type="date" />
							</div>
						</div>
						<div className="fg">
							<label>Production unit</label>
							<select defaultValue="Jigani Unit 1">
								<option>Jigani Unit 1</option>
								<option>Jigani Unit 2</option>
								<option>Gurugram Unit</option>
							</select>
						</div>
						<div style={{ margin: "14px 0 8px", fontSize: 11, fontWeight: 500, color: palette.ink3 }}>
							Trims allocation
						</div>
						<div className="line-items">
							{styleLines.map((row) => (
								<div className="line-item" key={row.code}>
									<div className="li-grid">
										<div className="fg">
											<label>Trim</label>
											<input defaultValue={row.trim} />
										</div>
										<div className="fg">
											<label>Vendor</label>
											<input defaultValue={row.vendor} />
										</div>
										<div className="fg">
											<label>Per Pc</label>
											<input defaultValue={row.perPc} />
										</div>
										<div className="fg">
											<label>Code</label>
											<input defaultValue={row.code} />
										</div>
										<div className="fg">
											<label>Type</label>
											<input defaultValue="Required" />
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="fg">
							<label>Internal notes</label>
							<textarea placeholder="Production notes..." />
						</div>
					</div>
					<div className="modal-footer">
						<button className="pbtn" onClick={closeModal}>
							Cancel
						</button>
						<button className="pbtn primary" onClick={closeModal}>
							Generate PO
						</button>
					</div>
				</div>
			</div>
		</Box>
	);
};

export default TrimsERP;
